export class AppEnvironment {
  public static SCREENSHOT_MODE = false;

  static EXAMPLE_IMAGE(text: string) {
    let rand = 0;
    let max = 7;
    for (let rat = 0; rat < text.length; rat++) {
      rand += text.charCodeAt(rat);
      if (rat >= max)
        break;
    }
    rand = rand % 4 + 1;
    return '/assets/img/channelpreview/preview0' + rand + '.png';
  }

  public static ANONYMIZE(text: string) {
    text = text.replace("Feinschnitt", "Legacyprodukt");
    text = text.replace("FEINSCHNITT", "LEGACYPRODUKT");
    text = text.replace("Philip Morris", "Muster");
    text = text.replace("PMG", "Muster GmbH");
    text = text.replace("PHILIP MORRIS", "MUSTER");
    text = text.replace("IQOS", "Musterprodukt");
    text = text.replace("OTP", "Special");
    text = text.replace("CHE", "Schweiz");
    text = text.replace("MLB", "Kassenschlager");
    text = text.replace("HEETS", "Ersatzteile");
    text = text.replace("Heets", "Ersatzteile");
    text = text.replace("CDR", "Produktverkauf");
    text = text.replace(" FL", " Fachhändler");
    text = text.replace(" UX", " (Kat. A)");
    text = text.replace(" no ", " kein ");
    text = text.replace("KAM", "Gruppe");
    text = text.replace("Sebastian", "Max");
    text = text.replace("Braun", "Mustermann");
    text = text.replace("Shell", "Oceanfuel");
    text = text.replace("SHELL", "OCEANFUEL");
    text = text.replace("Total", "Alltank");
    text = text.replace("TOTAL", "ALLTANK");
    text = text.replace("Aral", "Bluzapf");
    text = text.replace("ARAL", "BLUZAPF");
    text = text.replace("Eurotrade", "Rupihandel");
    text = text.replace("EUROTRADE", "RUPIHANDEL");
    text = text.replace("Willer", "Imogni");
    text = text.replace("WILLER", "IMOGNI");
    text = text.replace("Team", "Friends");
    text = text.replace("TEAM", "FRIENDS");
    text = text.replace("Orlen", "Orly");
    text = text.replace("ORLEN", "ORLY");
    text = text.replace("Lother", "Heiner");
    text = text.replace("LOTHER", "HEINER");
    text = text.replace("Anton", "Falk");
    text = text.replace("ANTON", "FALK");
    text = text.replace("L&M", "Profiprodukt");
    text = text.replace("LM", "Profiprodukt");
    text = text.replace("5XL", "Extended");
    text = text.replace("Vielfalt Neu", "Multi");
    text = text.replace("Box_und_Zip", "Big");
    text = text.replace("Routing", "Verteiler");
    return text;
  }

}
